<rt-basic-multi-select
  [control]="control()"
  [selectOptions]="locationOptions()"
  [isInvalid]="isInvalid()"
  [isReadOnly]="isReadOnly()"
  [hasExtendedPreview]="true"
/>
